import { searchPapers } from '../services/indianExamsService';

// Defensive normalization to avoid crashes if fields are missing
export function normalizePaper(p) {
  return {
    id: p.id || p.paperId || p.uid || String(p.name || p.title || Math.random()),
    title: p.title || p.name || 'Untitled',
    year: Number(p.year) || null,
    category: String(p.category || 'uncategorized').toLowerCase(),
    examId: p.examId || p?.examInfo?.examId || 'unknown',
    questionCount: p.questionCount || p.totalQuestions || (p.questions ? p.questions.length : undefined),
    durationMinutes: p.durationMinutes || p.duration || undefined,
    isActive: typeof p.isActive === 'boolean' ? p.isActive : true,
    position: p.position || p.post || undefined,
    tags: p.tags || [],
    examType: p.examType || p.type || undefined,
    raw: p,
  };
}

/**
 * Loads previous year papers from the backend and normalizes them.
 * @returns {Promise<Array>} Array of normalized paper objects
 * @throws {Error} If API call fails
 */
export async function loadPreviousPapers() {
  const result = await searchPapers({ type: 'previous_paper' });
  
  // Handle API error responses
  if (result && result.success === false) {
    console.error('[loadPreviousPapers] API returned error:', result.error);
    throw new Error(result.error || 'Failed to load papers');
  }
  
  // Handle different response shapes:
  // - Direct array of papers
  // - Object with papers array: { papers: [...] }
  // - Object with success and papers: { success: true, papers: [...] }
  // - Object with data containing papers: { data: { papers: [...] } }
  let papersArr;
  
  if (Array.isArray(result)) {
    papersArr = result;
  } else if (Array.isArray(result?.papers)) {
    papersArr = result.papers;
  } else if (Array.isArray(result?.data?.papers)) {
    papersArr = result.data.papers;
  } else if (Array.isArray(result?.data)) {
    papersArr = result.data;
  } else {
    console.warn('[loadPreviousPapers] Unexpected response shape:', result);
    papersArr = [];
  }
  
  return papersArr.map(normalizePaper);
}
